import { render, staticRenderFns } from "./WaybillRelationOrders.vue?vue&type=template&id=3a230154&"
import script from "./WaybillRelationOrders.vue?vue&type=script&lang=js&"
export * from "./WaybillRelationOrders.vue?vue&type=script&lang=js&"
import style0 from "./WaybillRelationOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports